var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeSlashIconOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.31793 5.85214C2.54867 6.76152 1.96167 7.83001 1.61328 9.00123C2.68936 12.615 6.03724 15.25 10.0006 15.25C10.8277 15.25 11.628 15.1352 12.3865 14.9207M5.19101 4.18969C6.57122 3.27965 8.22441 2.75 10.0013 2.75C13.9646 2.75 17.3125 5.38504 18.3886 8.99877C17.7953 10.9932 16.5101 12.6898 14.8113 13.81M5.19101 4.18969L2.50132 1.5M5.19101 4.18969L8.23355 7.23223M14.8113 13.81L17.5013 16.5M14.8113 13.81L11.7691 10.7678M11.7691 10.7678C12.2215 10.3154 12.5013 9.69036 12.5013 9C12.5013 7.61929 11.382 6.5 10.0013 6.5C9.31096 6.5 8.68596 6.77982 8.23355 7.23223M11.7691 10.7678L8.23355 7.23223",
    stroke: "#6F767E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlashIconOutline);
export default __webpack_public_path__ + "static/media/eyeSlashIconOutline.a90a4966448594bc4c96fe453e0e15bc.svg";
export { ForwardRef as ReactComponent };